
    import Vue from "vue";
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import { ApiClient } from "@/utilities/ApiClient";
    import { BookingActionDetailVM } from "@/model/Api/VM/BookingActionDetailVM";
    import { Utils } from "@/utilities/Utils";
    import { ScanMedium } from "@/model/Enums";
    
    @Component({
        components: {
            ApiButton
        }
    })

    export default class BookingActionDetailModal extends Vue {

        //
        // -- properties
        //

        private bookingAction = new BookingActionDetailVM();

        private get mediumOptions() {
            return Utils.enumToLookups(ScanMedium);
        }

        //
        // -- methods
        //

        open(actionID: string) {
            Utils.resetObject(this.bookingAction);
            this.loadBookingActionDetail(actionID);
        }

        async loadBookingActionDetail(actionID: string) {
            const response = await ApiClient.get(`/Api/Booking/BookingAction?id=${actionID}`);
            this.bookingAction.update(response);
            this.$bvModal.show("bookingActionDetailModal");
        }
        
        cancel() {
            this.$bvModal.hide("bookingActionDetailModal");
        }
    }

